module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/chevron_right.8c6dfb56.svg";